export class Airport {
    displayDescription: string;
    fsCode: string;
    hintDescription: string;
    apiMatchString: string;
}
